const PLATFORM_ALIASES = {
  fc: ['famicom', 'nes'],
  nes: ['nes', 'famicom'],
  famicom: ['famicom', 'nes'],
  md: ['megadrive', 'genesis'],
  megadrive: ['megadrive', 'genesis'],
  genesis: ['genesis', 'megadrive'],
  arcade: ['arcades'],
  arcades: ['arcades'],
  neogeo: ['arcades'],
  dos: ['pcclassics'],
  pc: ['pcclassics'],
  windows: ['pcclassics'],
  snes: ['snes', 'sfc'],
  sfc: ['sfc', 'snes'],
  gba: ['gameboyadvance'],
  ios: ['ios'],
  appleii: ['apple'],
  n64: ['nintendo64'],
  gb: ['gameboy'],
  ps: ['playstation'],
  ps1: ['playstation'],
  psp: ['playstationportable'],
  nds: ['nintendods'],
  ds: ['nintendods'],
  virtualboy: ['virtualboy']
};

export const normalizePlatformName = (value = '') =>
  String(value).toLowerCase().replace(/[^a-z0-9\u3400-\u9fff]/g, '');

export const getReleaseYear = (releaseDate) => {
  const match = String(releaseDate || '').match(/(?:^|\D)((?:19|20)\d{2})(?:\D|$)/);
  return match ? match[1] : '';
};

export const findPlatformId = (platforms, requestedPlatform) => {
  const requested = normalizePlatformName(requestedPlatform);
  if (!requested) return '';

  const normalizedPlatforms = platforms.map((platform) => ({
    ...platform,
    normalizedEnglish: normalizePlatformName(platform.nameeng),
    normalizedChinese: normalizePlatformName(platform.namechn)
  }));

  const exactMatch = normalizedPlatforms.find(
    (platform) =>
      platform.normalizedEnglish === requested ||
      platform.normalizedChinese === requested
  );
  if (exactMatch) return String(exactMatch.id);

  const aliases = PLATFORM_ALIASES[requested] || [];
  const aliasMatch = normalizedPlatforms.find((platform) =>
    aliases.some(
      (alias) =>
        platform.normalizedEnglish.includes(alias) ||
        platform.normalizedChinese.includes(alias)
    )
  );
  if (aliasMatch) return String(aliasMatch.id);

  if (requested.length >= 3) {
    const partialMatch = normalizedPlatforms.find(
      (platform) =>
        platform.normalizedEnglish.includes(requested) ||
        requested.includes(platform.normalizedEnglish) ||
        platform.normalizedChinese.includes(requested) ||
        requested.includes(platform.normalizedChinese)
    );
    if (partialMatch) return String(partialMatch.id);
  }

  return '';
};

